export const buildSelectValue = (values = []) => {
  const isArrayValue = Array.isArray(values)

  return {
    mode: isArrayValue && values.length > 0 ? 'custom' : 'all',
    values: isArrayValue ? [...values] : []
  }
}

export const getSelectValues = (selectValue) => {
  if (selectValue?.mode !== 'custom') return []
  return Array.isArray(selectValue.values) ? selectValue.values : []
}
